import Items from "../Items";
import { DecisionRow } from "./DecisionRow";

export const DecisionTable = ({ table, formularId }) => {
	//console.log(table)

	const tableId = table["@attributes"].id;
	const tableName = table["@attributes"].name;

	let rows = table.ZEILE;
	let selects;
	// let tableArr = table;
	const isArray = Array.isArray(rows);
	if (!isArray) {
		rows = [rows];
	}
	//console.log(table);
	//const isSelect = table.hasOwnProperty('SELECT');

	const isSelect = Object.keys(table).includes("SELECT");
	console.log("isSelect: " + isSelect);
	const rawRows = Array.isArray(table.ZEILE) ? table.ZEILE : [table.ZEILE];
	selects = isSelect
		? (Array.isArray(table.SELECT) ? table.SELECT : [table.SELECT])
		: [];

	//rows = rows.filter(row => row['@attributes'].visibility === "0");
	if (isSelect) {
		selects = table.SELECT;
		console.log(selects);
	}

	const getElementType = (row) => {
		if (isSelect) {
			return 'select';
		} else if (row.FELD['@attributes'].dbtable.includes('staff')) {
			return 'range'
		} else {
			return 'input'
		}
	}

	// console.log(tableArr)
	//console.log('rows')
	//console.log(rows)
	return (
		<div>
			<h4>{tableName}</h4>
			{
				rawRows
					.map((row, index) => ({ row, index })) // keep original index
					.filter(({ row }) => row['@attributes'].visibility === "0") // filter after
					.map(({ row, index }) => (
						<DecisionRow
							key={row.FELD['@attributes'].id}
							formularId={formularId}
							tableId={tableId}
							row={row}
							option={isSelect ? (selects[index] ? selects[index] : selects) : null}
							isSelect={isSelect}
							elementType={getElementType(row)}
						/>
					))
			}

		</div>
	);
}
